import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormControl, Validators } from '@angular/forms';
import { IssueDialogData } from '../../interfaces/issueDialogData';

@Component({
  selector: 'app-create-userstory-dialog',
  templateUrl: './create-userstory-dialog.component.html',
  styleUrls: ['./create-userstory-dialog.component.scss']
  })
export class CreateUserstoryDialogComponent implements OnInit {
  UsNameFormControl = new UntypedFormControl('', [
    Validators.required,
  ]);

  constructor(public dialogRef: MatDialogRef<CreateUserstoryDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IssueDialogData) { }

  ngOnInit() {
    this.dialogRef.disableClose = true;
  }

  cancel() {
    this.dialogRef.close();
  }
}
